// extracted by mini-css-extract-plugin
module.exports = {"card":"PopoverContent_card__3hLtW","cardTitle":"PopoverContent_cardTitle__2UrCE","search":"PopoverContent_search__2or-2"};